import React, { useState, useEffect } from "react";
import { useLoader } from "../../../../context/LoaderProvider.jsx";

const Settlement = () => {
  const [dataa, setDataa] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { showLoader, hideLoader } = useLoader();
  const [selectedDate, setSelectedDate] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const vendorId = localStorage.getItem("vendorId");
      const token = localStorage.getItem("authToken");

      if (!vendorId || !token) {
        setError("Missing vendorId or token");
        setLoading(false);
        return;
      }

      try {
        showLoader();

        const response = await fetch(
          `https://backend.maamaas.com/food/api/settlements/vendor/${vendorId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // Check if response is 404 (no settlements found)
        if (response.status === 404) {
          // console.log("No settlements found for vendor:", vendorId);
          setDataa([]); // Set empty array
          setError(null); // Clear any previous error
          setLoading(false);
          hideLoader();
          return;
        }

        if (!response.ok) {
          throw new Error(`Network response was not ok (${response.status})`);
        }

        const apiData = await response.json();

        if (!Array.isArray(apiData)) {
          throw new Error("Expected an array but got something else");
        }

        const transformedData = apiData.map((item, index) => ({
          sno: index + 1,
          settlementId: item.settlementId || "N/A",
          transactionId: `TXN${item.settlementId || 0}`,
          totalGrandTotal: `₹${(item.totalGrandTotal || 0).toLocaleString()}`,
          totalServiceCharge: `₹${(
            (item.totalServiceCharges || 0) + (item.totalPlatformCharges || 0)
          ).toLocaleString()}`,
          finalAmount: `₹${(item.amountAfterTds || 0).toLocaleString()}`,
          settlementDate: item.settlementDate || "N/A",
          status: item.paymentStatus || "Pending",
          pytMode: item.pytMode || "N/A",
          remarks: item.remarks || "-",
        }));

        setDataa(transformedData);
        setError(null);
      } catch (error) {
        console.error("Fetch error:", error);
        setError(error.message);
      } finally {
        setLoading(false);
        hideLoader();
      }
    };

    fetchData();
  }, []);

  const filteredData = selectedDate
    ? dataa.filter((item) => item.settlementDate === selectedDate)
    : dataa;

  const handleExportAll = () => {
    if (dataa.length === 0) {
      alert("No data to export!");
      return;
    }

    const headers = [
      "S.No",
      "Transaction ID",
      "Total Amount",
      "Charges",
      "Received Amount",
      "Date",
      "Status",
      "Payment",
      "Remarks",
    ];

    // Calculate totals
    const num = (s) => Number(String(s).replace(/[^0-9.-]/g, "") || 0);
    const totals = dataa.reduce(
      (acc, r) => ({
        totalGrandTotal: acc.totalGrandTotal + num(r.totalGrandTotal),
        totalServiceCharge: acc.totalServiceCharge + num(r.totalServiceCharge),
        finalAmount: acc.finalAmount + num(r.finalAmount),
      }),
      { totalGrandTotal: 0, totalServiceCharge: 0, finalAmount: 0 }
    );

    // Create rows with data - REMOVE ₹ SYMBOL for clean data
    const rows = dataa.map((r) => [
      r.sno,
      r.transactionId,
      num(r.totalGrandTotal), // Just the number, no ₹ symbol
      num(r.totalServiceCharge), // Just the number, no ₹ symbol
      num(r.finalAmount), // Just the number, no ₹ symbol
      r.settlementDate,
      r.status,
      r.pytMode,
      r.remarks,
    ]);

    // Add total row - also without ₹ symbols
    rows.push([
      "",
      "TOTAL",
      totals.totalGrandTotal.toLocaleString(),
      totals.totalServiceCharge.toLocaleString(),
      totals.finalAmount.toLocaleString(),
      "",
      "",
      "",
      "",
    ]);

    // Create CSV content with BOM for UTF-8 recognition
    const csvContent = [headers, ...rows]
      .map((row) => row.map((v) => `"${v}"`).join(","))
      .join("\n");

    // Add UTF-8 BOM and specify encoding
    const BOM = "\uFEFF";
    const blob = new Blob([BOM + csvContent], {
      type: "text/csv;charset=utf-8;"
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `Settlement-Report_${selectedDate || new Date().toISOString().split("T")[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  const datePickerStyle = {
    height: 35,
    marginTop: 20,
    marginRight: 10,
    borderRadius: 4,
    border: "1px solid #ccc",
    fontWeight: "bold",
    padding: "0 8px",
    color: "#fff",
    cursor: "pointer",
    backgroundColor: "#b15cd6"
  };

  return (
    <div style={{ width: window.innerWidth <= 756 ? "93%" : "100%", marginRight: "-10px" }}>
      {/* Filter and Export Buttons */}
      <div
        style={{
          display: "flex",
          gap: 10,
          justifyContent: "space-between",
          marginTop: -15,
          alignItems: "center",
        }}
      >
        <div>
          <input
            type="date"
            style={datePickerStyle}
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />
        </div>

        <div>
          <button style={{ ...btnStyle, marginRight: "0px", }} onClick={handleExportAll}>
            Export
          </button>
        </div>
      </div>

      {/* Table */}
      <div style={{
        overflowX: "auto",
        scrollbarWidth: "thin",
        marginTop: "10px",
        WebkitOverflowScrolling: "touch"
      }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginTop: 0,
            minWidth: "800px"
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#f2f2f2" }}>
              {[
                "S.No",
                "TransactionID",
                "Total Amount",
                "Charges",
                "ReceivedAmount",
                "Date",
                "Status",
                "Payment",
                "Remarks",
              ].map((h) => (
                <th key={h} style={thStyle}>
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((item, index) => (
                <tr
                  key={item.transactionId}
                  style={index % 2 === 0 ? evenRowStyle : oddRowStyle}
                >
                  <td style={tdStyle}>{item.sno}</td>
                  <td style={tdStyle}>{item.transactionId}</td>
                  <td style={tdStyle}>{item.totalGrandTotal}</td>
                  <td style={tdStyle}>{item.totalServiceCharge}</td>
                  <td style={tdStyle}>{item.finalAmount}</td>
                  <td style={tdStyle}>
                    {item.settlementDate
                      ? new Date(item.settlementDate).toLocaleDateString("en-GB")
                      : "N/A"}
                  </td>
                  <td style={tdStyle}>
                    <span
                      style={{
                        color: item.status === "RECEIVED" ? "green" : "orange",
                        fontWeight: "bold",
                      }}
                    >
                      {item.status}
                    </span>
                  </td>
                  <td style={tdStyle}>{item.pytMode}</td>
                  <td style={tdStyle}>{item.remarks}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" style={{ textAlign: "center", padding: 10 }}>
                  No records found 
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

/* Styles */
const thStyle = {
  border: "1px solid #ddd",
  textAlign: "center",
  fontWeight: "bold",
  backgroundColor: "#b15cd6",
  color: "white",
  padding: "8px 4px",
  fontSize: "1rem",
};
const tdStyle = {
  border: "1px solid #ddd",
  textAlign: "center",
  padding: "8px 4px",
};
const evenRowStyle = { backgroundColor: "#f9f9f9" };
const oddRowStyle = { backgroundColor: "#fff" };
const btnStyle = {
  height: 35,
  marginTop: 20,
  marginRight: 10,
  borderRadius: 4,
  border: "none",
  backgroundColor: "#b15cd6",
  color: "white",
  fontWeight: "bold",
  padding: "0 16px",
};

export default Settlement;